import { render, staticRenderFns } from "./list_categories_marketplace_component.vue?vue&type=template&id=495d290a&scoped=true"
import script from "./list_categories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./list_categories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./list_categories_marketplace_component.vue?vue&type=style&index=0&id=495d290a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d290a",
  null
  
)

export default component.exports